export default "__VITE_ASSET__C0ULKh4L__"